/**
 * @generated SignedSource<<887db2c2426eb66131eddaf094147cd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type eventosEnabledQuery$variables = {
  slug: string;
};
export type eventosEnabledQuery$data = {
  readonly club: {
    readonly configuration: string | null | undefined;
  };
};
export type eventosEnabledQuery = {
  response: eventosEnabledQuery$data;
  variables: eventosEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "EVENTS_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"EVENTS_ENABLED\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventosEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventosEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "02e0012c97c70091802e8f8a3fcb0bf6",
    "id": null,
    "metadata": {},
    "name": "eventosEnabledQuery",
    "operationKind": "query",
    "text": "query eventosEnabledQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    configuration(key: \"EVENTS_ENABLED\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ce092d32e5ecc5e624b2bff9fa922b7";

export default node;
